/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cute_Cool_Marlin_GulpInputs */

const fr_cute_cool_marlin_gulp = /** @type {(inputs: Cute_Cool_Marlin_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

/**

* @param {Cute_Cool_Marlin_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cute_cool_marlin_gulp = /** @type {((inputs?: Cute_Cool_Marlin_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cute_Cool_Marlin_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cute_cool_marlin_gulp(inputs)
});